<ng-container *ngIf="isVerificationFailed else successTemplate">
    <div class="failure-container">
        <p class="failure-message">
            Kortet kunne ikke bekreftes. Vanlige grunner til dette er at det er registrert på en annen person eller et selskap
        </p>
    </div>
</ng-container>
<ng-template #successTemplate>
    <div class="success-container">
        <p class="success-message">
            Kortet er bekreftet. Det tar opp til 30 sekunder før dette vises i listen
        </p>
    </div>
</ng-template>
